module.exports = __webpack_public_path__ + "static/media/pricing.5b15e44e.jpg";